import { Check, MailCheck, ShieldAlert } from "lucide-react";
import { type FormEvent, useState } from "react";

interface ProfileCompletionProps {
  initialName: string;
  saving: boolean;
  error?: string;
  onSave: (displayName: string, reengagementEnabled: boolean) => Promise<void>;
}

export function ProfileCompletion({
  initialName,
  saving,
  error,
  onSave,
}: ProfileCompletionProps) {
  const [displayName, setDisplayName] = useState(initialName.startsWith("Joueur-") ? "" : initialName);
  const [reengagementEnabled, setReengagementEnabled] = useState(false);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    void onSave(displayName, reengagementEnabled);
  };

  return (
    <div className="modal-backdrop">
      <form className="profile-completion" onSubmit={submit} aria-labelledby="profile-title">
        <ShieldAlert size={28} />
        <p className="eyebrow">Premier serment</p>
        <h2 id="profile-title">Choisis ton pseudonyme de Seigneur</h2>
        <p>Ce pseudonyme public t’identifiera dans le monde et dans les salons. N’utilise jamais ton nom civil.</p>
        <label htmlFor="display-name">Pseudonyme public</label>
        <input
          id="display-name"
          value={displayName}
          onChange={(event) => setDisplayName(event.target.value)}
          minLength={3}
          maxLength={24}
          autoComplete="nickname"
          autoFocus
          required
        />
        <small>3 à 24 caractères : lettres, nombres, espaces, apostrophes ou traits d’union.</small>

        <label className="consent-choice" htmlFor="reengagement-consent">
          <input
            id="reengagement-consent"
            type="checkbox"
            checked={reengagementEnabled}
            onChange={(event) => setReengagementEnabled(event.target.checked)}
          />
          <span className="consent-choice__icon" aria-hidden="true"><MailCheck size={18} /></span>
          <span>
            <strong>Me rappeler mon Bastion après une absence</strong>
            <small>Facultatif. Au maximum une relance après 7 jours d’absence, puis pas plus d’une tous les 30 jours. Tu pourras arrêter ces messages depuis ton profil ou l’e-mail reçu.</small>
          </span>
        </label>

        {error && <div className="notice notice--error" role="alert">{error}</div>}
        <button className="primary-command" type="submit" disabled={saving || displayName.trim().length < 3}>
          <Check size={18} /> {saving ? "Gravure en cours…" : "Confirmer ce pseudonyme"}
        </button>
      </form>
    </div>
  );
}
